/*global window,console*/
/*eslint no-console:0*/
define('app/models/Report',['require','./AnalyticsEntity','./Column','glu/collection','app/models/FieldFilter','app/models/Field','glu/util','config','glu/http','app/store','glu/$','app/models/ResultSet','app/config/strings','app/config/reportTypes','glu/appBus','app/app'],function(require) {
	'use strict';

	var AnalyticsEntity = require('./AnalyticsEntity'),
		Column = require('./Column'),
		Collection = require('glu/collection'),
		FieldFilter = require('app/models/FieldFilter'),
		Field = require('app/models/Field'),
		_ = require('glu/util'),
		config = require('config'),
		http = require('glu/http'),
		sessionStore = require('app/store'),
		$ = require('glu/$'),
		ResultSet = require('app/models/ResultSet'),
		strings = require('app/config/strings'),
		reportTypes = require('app/config/reportTypes'),
		appBus = require('glu/appBus'),
		APP = require('app/app');

	/**
	 * A Report is essentially an abstraction for a saved SQL query.
	 *
	 * A report consists of a name, description, a collection of columns, and a
	 * collection of filters. It keeps track of presentation options, such as the
	 * arrangement of columns in a grid, and other meta data such as the report owner.
	 */
	return AnalyticsEntity.extend({

		http: http,

		url: function() {
			return config.apiRoot + 'service/reports/' + this.id;
		},

		getReportData: function() {
			return this.serialize();
		},

		getDashboardId: function() {
			return this.get('dashboardId');
		},

		setDashboardId: function(d) {
			return this.set('dashboardId', d);
		},

		setOrderingCols: function(ordering) {
			if (ordering === false) {
				this.orderingCols = false;
			} else {
				this.orderingCols = true;
			}
		},

		getOrderingCols: function() {
			if (this.orderingCols !== undefined) {
				return this.orderingCols;
			} else {
				return true;
			}
		},

		getThreshold: function() {
			return this.get('threshold');
		},

		setThreshold: function(threshold) {
			return this.set('threshold', threshold);
		},

		// TODO: Storing the results is not unit tested.
		run: function() {
			var self = this;
			this.trigger('run');

			var requestData = this.getReportData();
			var debugData = {
				request: requestData
			};
			APP.reportLog.push(debugData);

			return this.http.post(config.apiRoot + 'service/runreport', requestData).then(function(results) {
				if (results) {
					if (results.sql) {
						APP.sql.push(results.sql);
					}
					debugData.results = results;

					self.addMissingInfoToResultsColumnHeader(requestData.columns, results.header);

					self.set('results', results, {
						silent: true
					});

					self.set('consumableResults', new ResultSet(results), {
						silent: true
					});

					self.trigger('dataReceived');
				}
			});

		},

		addMissingInfoToResultsColumnHeader: function(columns, header) {
			var domain = this.get('domain');

			_.each(columns, function(column, i) {
				if (header[i] && header[i].type) {
					column.type = header[i].type;
				}
				var dColumn = domain.buildColumn(column);
				if (header[i]) {
					header[i].fieldId = column.fieldId;
					header[i].segmentId = column.segmentId;
					header[i].function = column.function;
					header[i].funcArguments = column.funcArguments;
					header[i].columnType = column.columnType;
					header[i].sort = column.sort;
					header[i].aggregation = column.aggregation;
					header[i].asName = column.asName;
					header[i].enumeration = column.enumeration;
					header[i].title = dColumn.qualifiedName();
					header[i].displayFormat = dColumn.getDisplayFormat();
					header[i].isMeasure = dColumn.isMeasure();
					header[i].isPercentage = dColumn.isPercentage();
					header[i].fieldType = dColumn.getFieldType();

					if (header[i].asName) {
						header[i].name = header[i].asName;
					}
				}
			});
		},

		exportCsv: function() {

			var data = this.getReportData();

			return this.http.post(config.apiRoot + 'service/csv', data).then(function(d) {
				//redirect browser to new url
				var url = config.apiRoot + 'service/csv/' + d;
				window.open(url, '_self');
			});
		},

		exportJson: function() {
			var self = this;
			var deferred = new $.Deferred();
			var data = _.clone(self.getReportData());

			var segmentIds = this.getReportSegmentIds(data);

			// Remove ids
			data.dashboardId = undefined;
			data.reportId = undefined;
			data.id = undefined;

			// Remove enumerations
			// its unnecessary to export enumeration items
			_.each(data.columns, function(c) {
				c.enumeration = null;
			});

			if (segmentIds.length === 0) {
				// returns report V1 (without segments)
				return deferred.resolve(btoa(JSON.stringify(data)));
			} else {
				// returns report with segments V2
				var segments = [];
				_.each(segmentIds, function(segmentId) {
					segments.push(APP.segments.get(segmentId).toJSON());
				});

				var reportwitSegments = {
					version: 'V02',
					report: data,
					segments: segments
				};
				return deferred.resolve(btoa(JSON.stringify(reportwitSegments)));
			}
		},

		importJson: function(data) {
			return $.ajax(config.apiRoot + 'service/reportsJSON', {
				type: 'POST',
				contentType: 'application/json',
				data: data
			});
		},

		initialize: function(attrs) {
			var self = this;

			var filter = this.get('filter');

			if (filter && filter.on) {
				filter.on('change', function() {
					self.trigger('change');
				}, filter);
			} else {
				this.set('isDirty', false, {
					silent: true
				});
			}

			self.listenTo(this, 'change', function() {
				self.set('isDirty', true, {
					silent: true
				});
			});

			// If column data is passed into the constructor, we want to initialize the column collection now.
			if (attrs && attrs.columns) {
				this.attributes.columnCollection.reset(attrs.columns);
			}

			// Otherwise, whenever the column data changes (e.g. when the report is fetched), initialize the column collection
			self.listenTo(this, 'change:columns', function() {
				self.attributes.columnCollection.reset(self.attributes.columns);
			});

			self.listenTo(this.attributes.columnCollection, 'add remove change', function() {
				self.trigger('change');
			});

			// Timeout forces the clean() to run last in the chain
			if (attrs && attrs.builder) {
				window.setTimeout(function() {
					self.clean();
				}, 0);
			}
		},

		defaults: function() {
			return {
				modelName: strings.reportModelName,
				columnCollection: new Collection([], {
					model: Column
				}),
				options: {},
				isDirty: false,
				isPrivate: true,
				owner: sessionStore.getApiUsername()
			};
		},

		getReportType: function() {
			return this.get('reportType');
		},

		setReportType: function(reportType) {
			return this.set('reportType', reportType);
		},

		canBeDeleted: function() {
			return !this.isSpdReport() && this.isOwner();
		},

		getDomain: function() {
			return this.get('domain');
		},

		getDomainName: function() {
			return this.get('domain').get('name');
		},

		columns: function() {
			return this.attributes.columnCollection;
		},

		/**
		 * Using cid to guarantee uniqueness.  It is possible to add the same column to a report mutiple times.  We
		 * need to make sure we are always operating on the correct instance of the column.
		 */
		getColumnById: function(id) {
			return this.attributes.columnCollection.get(id);
		},

		moveColumnToGrouped: function(id) {
			this.moveColumnToCategory(id, 'grouped');
		},

		moveColumnToAggregated: function(id) {
			this.moveColumnToCategory(id, 'aggregated');
		},

		moveColumnToUncategorized: function(id) {
			this.moveColumnToCategory(id, 'uncategorized');
		},

		moveColumnToCategory: function(id, category) {
			var column = this.getColumnById(id);

			column.setManualAsName(false);

			if (category === 'aggregated') {
				column.setDefaultAggregation();
				// move it to the end
			} else if (category === 'grouped') {
				column.setAggregation(undefined);
			}
		},

		canMoveColumnToCategory: function(id, category) {
			if (category === 'grouped') {
				var column = this.getColumnById(id);
				return column.canBeGrouped();
			}
			return true;
		},

		isGroupedAndAggregated: function() {
			var val = this.get('options').isGroupedAndAggregated;
			return (val === 'TRUE' || val === true) && this.hasColumns();
		},

		setGroupedAndAggregated: function(flag) {
			this.get('options').isGroupedAndAggregated = flag ? 'TRUE' : 'FALSE';
		},

		setUrlOrigin: function(url) {
			this.get('options').urlOrigin = url;
		},

		getUrlOrigin: function() {
			return this.get('options').urlOrigin;
		},

		addGroupCountColumn: function() {
			if (this.hasGroupCountColumn()) {
				return;
			}

			var self = this;

			var column = new Column({
				columnType: 'COUNT',
				asName: 'Record Count',
				isHidden: false,
				isGroup: false,
				fieldObject: {
					displayName: _.constant('Record Count'),
					isMeasure: function() {
						return self.isGroupedAndAggregated();
					},
					name: _.constant('Record Count')
				}
			});
			this.columns().add(column);
		},

		removeGroupCountColumn: function() {
			if (this.hasGroupCountColumn()) {
				this.columns().findWhere({
					columnType: 'COUNT'
				}).remove();
			}
		},

		groupCountColumn: function() {
			return this.columns().findWhere({
				columnType: 'COUNT'
			});
		},

		hasGroupCountColumn: function() {
			return !!this.groupCountColumn();
		},

		hasInvalidFilters: function() {
			return !!this.filter() && !this.filter().isValid();
		},

		removeColumnById: function(id) {
			this.getColumnById(id).remove();
		},

		eachColumn: function(fn) {
			this.columns().each(fn);
		},

		eachVisibleColumn: function(fn) {
			this.columns().each(function(c) {
				if (!c.isCountColumn()) {
					fn(c);
				}
			});
		},

		addColumnById: function(id, doNotDuplicate) {
			if (doNotDuplicate && this.attributes.columnCollection.where({
					fieldId: id
				}).length > 0) {
				return;
			}

			var column = this.get('domain').buildColumn({
				fieldId: id
			});

			//based on the dimension or measure add the column to the front or end
			// dimensions go to the front, measures go to the end
			if (column.isMeasure()) {
				this.attributes.columnCollection.add(column);
			} else {
				this.attributes.columnCollection.add(column, {
					at: 0
				});
			}
		},

		addVirtualColumnAsColumn: function(col) {
			var column = this.get('domain').buildColumn(col);

			this.attributes.columnCollection.add(column);
		},

		addSegmentAsColumnById: function(segmentId) {
			var segment = APP.segments.get(segmentId);

			var column = this.get('domain').buildColumn({
				segmentId: segmentId,
				columnType: 'SEGMENT',
				name: segment.get('name')
			});

			this.attributes.columnCollection.add(column);
		},

		loadSegmentById: function(id) {
			var self = this,
				filterData;

			if (id) {
				filterData = APP.segments.get(id) ? APP.segments.get(id).get('filters') : undefined;

				if (filterData) {
					// build filter collection from the segment
					var filters = self.get('domain').buildFilter(filterData).filterCollection();

					if (self.getReportType() === reportTypes.SEGMENT) {
						_.each(filters.models, function(filter) {
							self.filter().filterCollection().add(filter);
						});
					} else {
						// add filters from the segment to existing report filters
						_.each(filters.models, function(filter) {
							// have to reset collection reference before add
							// current collection implementation does not update the model.collection reference if model already contains it
							// will allow to delete new filters
							filter.collection = null;
							filter.set('segmentId', id);
							self.filter().filterCollection().add(filter);
						});
					}
				}
			}
		},

		loadFilters: function(filterData) {
			var self = this;

			if (filterData) {
				var filters = self.get('domain').buildFilter(filterData);
				self.get('filter').set('filterCollection', filters.get('filterCollection'));
			}
		},

		addSpdColumns: function() {
			var self = this;
			_.each(this.get('domain').spdFieldIds(), function(id) {
				self.addColumnById(id, true);
			});
		},

		isRunnable: function() {

			if (this.hasNoColumns()) {
				return false;
			}

			var filter = this.filter();

			if (filter && !filter.isValid()) {
				return false;
			}

			return true;
		},

		isNotRunnable: function() {
			return !this.isRunnable();
		},

		hasNoColumns: function() {
			return !this.hasColumns();
		},

		countGroupColumns: function() {
			return this.get('columnCollection').filter(function(c) {
				return !c.hasAggregation();
			}).length;
		},

		hasGroupColumns: function() {
			return this.get('columnCollection').filter(function(c) {
				return !c.hasAggregation();
			}).length > 0;
		},

		countAggregateColumns: function() {
			return this.get('columnCollection').filter(function(c) {
				return c.hasAggregation();
			}).length;
		},

		hasAggregateColumns: function() {
			return this.get('columnCollection').filter(function(c) {
				return c.hasAggregation();
			}).length > 0;
		},

		hasColumns: function() {
			return this.get('columnCollection').reject(function(c) {
				return c.isCountColumn();
			}).length > 0;
		},

		hasSelectedCell: function() {
			return !!this.get('selectedId');
		},

		filter: function() {
			var filter = this.get('filter');
			return filter;
		},

		getFilters: function() {
			return this.get('filters');
		},

		setFilters: function(value) {
			return this.set('filters', value);
		},

		// TODO: The UI should not have generic "options". Each option should map to a first-class property
		// of a Report. We have ReportBuilder and toJSON to decouple the API representation of a report from
		// representation used here. We should take advantage of them.

		setOption: function(key, value) {
			this.get('options')[key] = value;
		},

		getOption: function(key) {
			return this.get('options')[key];
		},

		setAllColumnsToAggregate: function() {
			this.columns().each(function(c) {
				c.setManualAsName(false);
				if (!c.hasAggregation()) {
					c.setDefaultAggregation();
				}
				c.setAsName(c.getAggregation() + '(' + c.fieldName() + ')');
			});
		},

		toJSON: function() {
			var self = this;

			//REVIEW: We can move this logic into Column.toJSON(). We would just have to add a toJSONWithoutAggregation function as well.
			var mapColumn = function(c) {
				var result;

				result = {
					uniqueId: c.cid,
					fieldId: c.fieldId() || undefined,
					columnType: c.isCountColumn() ? 'COUNT' : null,
					isHidden: c.isHidden(),
					sort: c.getSort(),
					asName: c.displayName({
						excludeAggregation: !self.isGroupedAndAggregated()
					}), // TODO: Not tested. Will be easier to test when we move the logic inside Column
					arrangement: c.get('arrangement'),
					enumeration: c.getEnumeration(),
					isPercentage: c.isPercentage()
				};

				if (self.isGroupedAndAggregated()) {
					result.isGroup = !c.hasAggregation();
					result.aggregation = c.getAggregation();
				} else if ((!self.isGroupedAndAggregated() && (c.fieldName() === c.displayName()) || (c.hasAggregation() && c.fieldName() !== c.displayName()))) { //this is to enable the renaming of column feature to remove aggregation when the display name is un-aggregated (Group by check box is unchecked. Also fixes NH-15102)
					c.setAsName(undefined);
					result.asName = c.displayName({
						excludeAggregation: !self.isGroupedAndAggregated()
					});
					c.setAggregation(undefined);
					result.aggregation = c.getAggregation();
				}

				if (c.get('segmentId')) {
					result.segmentId = c.get('segmentId');
					result.columnType = c.get('columnType');
				}

				if (c.get('columnType') === 'FUNCTION') {
					result.enumeration = undefined;
					result.asName = c.displayName({
						excludeAggregation: !self.isGroupedAndAggregated()
					});
					result.name = c.get('name');
					result.funcArguments = c.get('funcArguments');
					result.columnType = c.get('columnType');
					result.function = c.get('function');
				}

				return result;
			};

			var columns = this.columns().map(mapColumn);

			if (!self.isGroupedAndAggregated()) {
				columns = _.reject(columns, function(c) {
					return c.columnType === 'COUNT';
				});
			}

			var serialized = {};

			if (this.getOrderingCols()) {
				serialized.columns = columns.sort(function(A, B) {
					if (A.columnType === 'COUNT') {
						return 1;
					}
					if (B.columnType === 'COUNT') {
						return -1;
					}
					return 0;
				});

			} else {
				serialized.columns = columns;
			}

			if (this.get('filter')) {
				serialized.filters = this.get('filter').toJSON();
			}

			// process column visual settings, like percentage representation
			var getColumnOptions = function(c) {
				var output = {};

				output = {
					uniqueId: c.cid,
					isPercentage: c.isPercentage(),
					aggregation: c.get('aggregation')
				};

				if (c.get('fieldId')) {
					output.fieldId = c.get('fieldId');
				}

				if (c.get('segmentId')) {
					output.segmentId = c.get('segmentId');
				}

				if (c.get('function')) {
					output.function = c.get('function');
					output.name = c.get('name');
				}

				return output;
			};

			var visualOptions = this.get('options');

			visualOptions.columns = JSON.stringify(self.columns().map(getColumnOptions));

			serialized.visual = {
				options: visualOptions
			};

			serialized.id = this.get('id');
			serialized.domainId = this.get('domainId');
			serialized.dashboardId = this.get('dashboardId');

			serialized.name = this.get('name');
			serialized.description = this.get('description');
			serialized.reportType = this.get('reportType');
			serialized.isPrivate = this.getIsPrivate();

			return serialized;
		},

		isSaved: function() {
			return !!this.get('id');
		},

		removeMasterFilter: function() {
			var domain = this.get('domain');
			var filterId = domain.getMasterFilter().fieldId();
			var filterName = domain.getMasterFilter().fieldName();
			var collection = this.filter().filterCollection().clone();
			collection.remove(collection.filter(function(model) {
				return (model.fieldId() === filterId && model.fieldName() === filterName);
			}));
			return collection.toJSON();
		},

		save: function() {
			var jsonData = this.toJSON();

			// remove filter of type 'master filter' if saving as a widget
			if (this.getWidgetType() && this.get('domain').getMasterFilter()) {
				var filter = this.removeMasterFilter();
				jsonData.filters.operands = filter;
			}
			var self = this;
			return $.ajax(config.apiRoot + 'service/reports', {
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(jsonData)
			}).then(function(data) {
				self.set('id', data.id);
				// save follow
				var distribution = self.get('distrInfo');
				if (distribution) {
					distribution.reportId = data.id;
					http.post(config.apiRoot + 'service/setreportdistribution', distribution);
				}
				self.get('domain').trigger('report:reload');
				return {
					id: data.id,
					domainId: data.domainId,
					dashboardId: data.dashboardId
				};
			});
		},

		// saves without removing the master filter, used by alert reports
		saveAsIs: function() {
			var jsonData = this.toJSON();

			var self = this;
			return $.ajax(config.apiRoot + 'service/reports', {
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(jsonData)
			}).then(function(data) {
				self.set('id', data.id);
				self.get('domain').trigger('report:reload');
				return {
					id: data.id,
					domainId: data.domainId,
					dashboardId: data.dashboardId
				};
			});
		},

		saveAlertReport: function(name, description) {
			var jsonData = this.toJSON();

			// clean up the id so, it is saved as a new report with no dashboard
			jsonData.id = null;
			jsonData.reportType = 'ALERT';
			jsonData.name = name;
			jsonData.description = description;
			jsonData.isPrivate = true;
			jsonData.dashboardId = null;

			return $.ajax(config.apiRoot + 'service/reports', {
				type: 'POST',
				contentType: 'application/json',
				async: false,
				data: JSON.stringify(jsonData)
			}).done(function(data) {
				return data.id;
			});
		},

		// results is deprecated in favor of consumableResults
		// eventually consumableResults will be renamed to just "results"
		// The idea is to make results return an object with methods rather
		// than a simple data structure so that visualizations can obtain
		// views of the results sliced and diced according to their needs.
		results: function() {
			return this.get('results');
		},

		consumableResults: function() {
			return this.get('consumableResults');
		},

		isDirty: function() {
			return !!this.get('isDirty');
		},

		setDirty: function() {
			this.set('isDirty', false); // need to trigger model change even it was dirty already
			this.set('isDirty', true);
		},

		clean: function() {
			this.set('isDirty', false, {
				silent: true
			});
			this.filter().clean();
		},

		isDashboardCompatible: function() {
			if (this.isNotRunnable()) {
				return false;
			}
			if (this.get('options').dashboardWidgetType) {
				return true;
			}
			return false;
		},

		/**
		 * Reports can only be saved as kpi widgets if they have exactly one measure and exactly one row.
		 */
		hasKpi: function() {
			var results = this.results();
			var columns = this.columns();
			var isOneRow = !!results && results.rows.length === 1;
			//determine the number of 'isMeasure' columns
			var nMeasures = 0; //for some reason, I tried _.reduce() and it was causing 'undefined' errors :(
			for (var i = 0; i < columns.length; i++) {
				nMeasures += columns.at(i).isMeasure() ? 1 : 0;
			}

			return isOneRow && nMeasures === 1;
		},

		/**
		 * Reports can only be saved as top 10 widgets if they have exactly 2 columns and at least one row.
		 */
		hasTop10ListResults: function() {
			var results = this.results(),
				hasAtLeastOneRow = !!results && results.rows.length > 0;
			return this.columns().length === 2 && hasAtLeastOneRow;
		},

		/**
		 * Determine if a report is in a renderable state.  This also impacts which options are enabled in the save as dialog.
		 */
		canRenderReport: function() {
			var self = this;
			var consumableResults = this.consumableResults();

			switch (this.getVisualization()) {
				case 'table':
					return this.columns().length > 0;
				case 'donut-chart':
					return self.hasAggregateColumns() && self.hasSelectedCell() && consumableResults && consumableResults.recordCount() > 0 && consumableResults.recordCount() <= this.getMaxRecordCount();
				case 'pivot-table':
					return self.hasAggregateColumns() && consumableResults && consumableResults.categoryCount() === 2 && consumableResults.measureCount() === 1 && consumableResults.recordCount() <= this.getMaxRecordCount();
				case 'line-chart':
				case 'bar-chart':
				case 'pie-chart':
					return self.hasAggregateColumns() && consumableResults && consumableResults.hasCategoriesAndMeasures() && consumableResults.measureCount() >= 1 && consumableResults.recordCount() > 0 && consumableResults.recordCount() <= this.getMaxRecordCount();
				case 'stacked-bar-chart':
					return self.hasAggregateColumns() && consumableResults && consumableResults.hasCategoriesAndMeasures() && consumableResults.measureCount() === 1 && consumableResults.recordCount() > 0 && consumableResults.recordCount() <= this.getMaxRecordCount();
				case 'scatter-plot':
					return self.hasAggregateColumns() && consumableResults && consumableResults.hasCategoriesAndMeasures() && consumableResults.measureCount() >= 2 && consumableResults.measureCount() <= 3 && consumableResults.categoryCount() === 1 && consumableResults.recordCount() > 0 && consumableResults.recordCount() <= this.getMaxRecordCount();
				default:
					return self.hasAggregateColumns() && consumableResults && consumableResults.hasCategoriesAndMeasures() && consumableResults.recordCount() > 0 && consumableResults.recordCount() <= this.getMaxRecordCount();
			}
		},

		getReasonForCannotRenderReport: function() {
			var self = this;
			var consumableResults = this.consumableResults();

			if (!this.canRenderReport()) {
				if (consumableResults.recordCount() === 0) {
					return 'the report has no data';
				}

				switch (this.getVisualization()) {
					case 'table':
						break;
					case 'donut-chart':
						if (consumableResults.recordCount() > this.getMaxRecordCount()) {
							return 'a donut chart must have fewer than ' + this.getMaxRecordCount() + ' rows';
						}
						if (this.columns().length === 0) {
							return 'a donut chart must have at least one column';
						}
						if (!self.hasAggregateColumns()) {
							return 'a donut chart must have at least one aggregated column';
						}
						if (!self.hasSelectedCell()) {
							return 'a donut chart must have a selected cell from an aggregated column';
						}
						break;
					case 'pivot-table':
						if (consumableResults.recordCount() > this.getMaxRecordCount()) {
							return 'a pivot table must have fewer than ' + this.getMaxRecordCount() + ' rows';
						}
						if (this.columns().length === 0) {
							return 'a pivot table chart must have at least one column';
						}
						if (!self.hasAggregateColumns()) {
							return 'a pivot table must have an aggregated column';
						}
						if (consumableResults.categoryCount() !== 2) {
							return 'a pivot table must have two grouped columns';
						}
						if (consumableResults.measureCount() !== 1) {
							return 'a pivot table must have one measure column';
						}
						break;
					case 'bar-chart':
						if (consumableResults.recordCount() > this.getMaxRecordCount()) {
							return 'a bar chart must have fewer than ' + this.getMaxRecordCount() + ' rows';
						}
						if (this.columns().length === 0) {
							return 'a bar chart must have at least one column';
						}
						if (!self.hasAggregateColumns()) {
							return 'a bar chart must have at least one aggregated column';
						}
						if (!consumableResults.hasCategoriesAndMeasures()) {
							return 'a bar chart must have a grouped column';
						}
						if (consumableResults.measureCount() !== 1) {
							return 'a bar chart must have one measure column';
						}
						break;
					case 'line-chart':
						if (consumableResults.recordCount() > this.getMaxRecordCount()) {
							return 'a line chart must have fewer than ' + this.getMaxRecordCount() + ' rows';
						}
						if (this.columns().length === 0) {
							return 'a line chart must have at least one column';
						}
						if (!self.hasAggregateColumns()) {
							return 'a line chart must have at least one aggregated column';
						}
						if (!consumableResults.hasCategoriesAndMeasures()) {
							return 'a line chart must have a grouped column';
						}
						if (consumableResults.measureCount() !== 1) {
							return 'a line chart must have one measure column';
						}
						break;
					case 'pie-chart':
						if (consumableResults.recordCount() > this.getMaxRecordCount()) {
							return 'a pie chart must have fewer than ' + this.getMaxRecordCount() + ' rows';
						}
						if (this.columns().length === 0) {
							return 'a pie chart must have at least one column';
						}
						if (!self.hasAggregateColumns()) {
							return 'a pie chart must have at least one aggregated column';
						}
						if (!consumableResults.hasCategoriesAndMeasures()) {
							return 'a pie chart must have a grouped column';
						}
						if (consumableResults.measureCount() !== 1) {
							return 'a pie chart must have one measure column';
						}
						break;
					case 'stacked-bar-chart':
						if (consumableResults.recordCount() > this.getMaxRecordCount()) {
							return 'a stacked bar chart must have fewer than ' + this.getMaxRecordCount() + ' rows';
						}
						if (this.columns().length === 0) {
							return 'a stacked bar chart must have at least one column';
						}
						if (!self.hasAggregateColumns()) {
							return 'a stacked bar chart must have at least one aggregated column';
						}
						if (!consumableResults.hasCategoriesAndMeasures()) {
							return 'a stacked bar must have a grouped column';
						}
						if (consumableResults.measureCount() !== 1) {
							return 'a stacked bar must have one measure column';
						}
						break;
					case 'scatter-plot':
						if (consumableResults.recordCount() > this.getMaxRecordCount()) {
							return 'a scatter plot must have fewer than ' + this.getMaxRecordCount() + ' rows';
						}
						if (this.columns().length === 0) {
							return 'a scatter plot must have at least one column';
						}
						if (!self.hasAggregateColumns()) {
							return 'a scatter plot must have at least one aggregated column';
						}
						if (!consumableResults.hasCategoriesAndMeasures()) {
							return 'a scatter plot must have a grouped column';
						}
						if (consumableResults.measureCount() < 2 || consumableResults.measureCount() > 3) {
							return 'a scatter plot must have two or three measures';
						}
						break;
					default:
						return 'the report is invalid';
				}
			}
		},

		getWidgetType: function() {
			return this.get('options').dashboardWidgetType;
		},

		setWidgetType: function(widgetType) {
			this.get('options').dashboardWidgetType = widgetType;
		},

		// TODO: Move the matching logic in to Column
		findColumn: function(criteria) {
			var matchingColumn;
			var foundMatch = false;

			this.columns().each(function(column) {

				if (foundMatch) {
					return;
				}

				if (criteria.columnType === 'COUNT') {
					if (column.isCountColumn()) {
						matchingColumn = column;
						foundMatch = true;
					}
					return;
				}

				if (criteria.fieldId && column.fieldId() !== criteria.fieldId) {
					return;
				}
				if (criteria.aggregation && column.getAggregation() !== criteria.aggregation) {
					return;
				}

				matchingColumn = column;
				foundMatch = true;
			});

			if (foundMatch) {
				return matchingColumn;
			} else {
				return new Column(_.extend(criteria, {
					isHidden: true
				}));
			}

		},

		sortColumn: function(criteria, order) {
			// get high priority order in the columns
			var minSortPriorityCounter = _.min(this.columns().map(function(column) {
				return column.getSort() ? column.getSort().priority : 0;
			}));
			this.findColumn(criteria).setSort(order.toUpperCase(), --minSortPriorityCounter);
		},

		setColumnArrangement: function(criteria, index) {
			var column = this.findColumn(criteria);
			column.setArrangement(index);
			// rearrange the column order in the columnCollection
			this.attributes.columnCollection.remove(column);
			this.attributes.columnCollection.add(column, {
				at: index
			});
		},

		setVisualization: function(name) {
			this.setOption('selectedVisualization', name);
			this.trigger('change:visualization');
			appBus.trigger('nav:render');
		},

		getVisualization: function() {
			return this.getOption('selectedVisualization') || 'table';
		},

		/**
		 * Returns true if current visualization is line or bar chart.
		 */
		isChart: function() {
			return this.isBarChart() || this.isLineChart() || this.isPieChart() || this.isStackedBarChart() || this.isScatterPlot();
		},

		/**
		 * Returns true if the current visualization is a line chart.
		 */
		isLineChart: function() {
			return this.getVisualization() === 'line-chart';
		},

		/**
		 * Returns true if the current visualization is a bar chart.
		 */
		isBarChart: function() {
			return this.getVisualization() === 'bar-chart';
		},

		/**
		 * Returns true if this current visualization is a stacked bar chart.
		 */
		isStackedBarChart: function() {
			return this.getVisualization() === 'stacked-bar-chart';
		},

		/**
		 * Returns true if the current visualization is a pie chart.
		 */
		isPieChart: function() {
			return this.getVisualization() === 'pie-chart';
		},

		/**
		 * Returns true if the current visualization is a scatter plot.
		 */
		isScatterPlot: function() {
			return this.getVisualization() === 'scatter-plot';
		},

		/**
		 * Returns true if the current visualization is a table.
		 */
		isTable: function() {
			return this.getVisualization() === 'table';
		},

		getDistrData: function() {
			return this.get('distrInfo');
		},

		setFollowSchedule: function(payload) {
			var self = this;

			self.set('distrInfo', payload, {
				silent: true
			});

			self.set('isFollowing', payload.schedule !== 'NONE', {
				silent: true
			});
			self.trigger('change:distribution');
		},

		sendReportLink: function(payload) {
			return this.http.post(config.apiRoot + 'service/sendmessage', payload).then(function(res) {
				return res.data;
			});
		},

		setAlert: function(payload) {
			return this.http.post(config.apiRoot + 'service/threshold', payload).then(function(res) {
				return res;
			});
		},

		deleteAlert: function() {
			var threshold = this.get('threshold');
			return $.ajax(config.apiRoot + 'service/threshold/' + threshold.id, {
				type: 'DELETE'
			});
		},

		saveAlertAs: function(name, description) {
			var self = this;
			console.log(name + '-' + description);
			// at this point, a new 'snapshot' report of the current report is created
			return self.saveAlertReport(name, description).then(function(report) {
				var alert = self.getThreshold();
				alert.id = undefined;
				alert.reportId = report.id;

				return self.setAlert(alert).then(function(result) {
					result.domainId = self.getDomainId();
					return result;
				});
			});
		},

		/**
		 * Get the max records allowed for the current visualization.  Currently, the pie chart is the only
		 * visualization that has special requirements.
		 */
		getMaxRecordCount: function() {
			switch (this.getVisualization()) {
				case 'pie-chart':
					return 75;
				case 'stacked-bar-chart':
					return 50;
				case 'donut-chart':
					return 10000;
				default:
					return 1000;
			}
		},

		addFieldEqualsValueFilter: function(fieldId, value) {
			var equalsFilter,
				filterExists;

			filterExists = !!this.filter().get('filterCollection').models.filter(function(filter) {
				if (filter.get('fieldObject')) {
					return filter.get('fieldObject').get('id') === fieldId;
				}
			})[0];

			equalsFilter = this.get('domain').buildEmptyFilterForFieldId(fieldId);

			if (value === null) {
				equalsFilter.setOperator('ISNULL');
			} else {
				equalsFilter.setOperator('EQ');
				equalsFilter.setValue(0, value);
			}

			if (filterExists) {
				this.filter().replaceFilter(equalsFilter);
			} else {
				this.filter().addFilter(equalsFilter);
			}
		},

		getFieldEqualsValueFunctionFilter: function(column, value) {
			var self = this,
				equalsFilter,
				fnColumn;
			if (!column || !column.get) {
				fnColumn = _.find(self.get('domain').get('functions'), function(fn) {
					return fn.name === column.function;
				});

				if (fnColumn.arguments && column.funcArguments) {
					for (var i = 0; i < fnColumn.arguments.length; i++) {
						_.extend(fnColumn.arguments[i], column.funcArguments[i]);
					}
				}

				equalsFilter = new FieldFilter({
					operator: 'EQ',
					fieldObject: new Field({
						id: fnColumn.name,
						name: fnColumn.displayName || column.name,
						type: fnColumn.type
					}),
					funcArguments: fnColumn.arguments,
					columnType: 'FUNCTION'
				});
			} else {
				equalsFilter = new FieldFilter({
					operator: 'EQ',
					fieldObject: new Field({
						id: column.get('function'),
						name: column.get('displayName') || column.get('name'),
						type: column.get('type')
					}),
					funcArguments: column.get('funcArguments'),
					columnType: 'FUNCTION'
				});
			}

			if (typeof value !== 'undefined') {
				equalsFilter.setValue(0, value);
			}

			return equalsFilter;
		},

		addFieldEqualsValueFunctionFilter: function(column, value) {
			var filterExists,
				equalsFilter,
				functionName = '';

			if (column.get && column.get('function')) {
				functionName = column.get('function');
			}

			if (column.function) {
				functionName = column.function;
			}

			filterExists = !!this.filter().get('filterCollection').models.filter(function(filter) {
				if (filter.get('fieldObject')) {
					return filter.get('fieldObject').get('id') === functionName;
				}
			})[0];

			equalsFilter = this.getFieldEqualsValueFunctionFilter(column, value);

			if (filterExists) {
				this.filter().replaceFilter(equalsFilter);
			} else {
				this.filter().addFilter(equalsFilter);
			}
		},

		getFieldEqualsValueSegmentFilter: function(column, value) {
			var equalsFilter,
				segmentId = '',
				operator;

			if (column.get && column.get('segmentId')) {
				segmentId = column.get('segmentId');
			}

			if (column.segmentId) {
				if (_.isFunction(column.segmentId)) {
					segmentId = column.segmentId();
				} else {
					segmentId = column.segmentId;
				}
			} else if (column.id) {
				segmentId = column.id;
			}

			if (!column || !column.get) {
				column = APP.segments.get(segmentId);
			}

			operator = 'EQ';
			equalsFilter = new FieldFilter({
				operator: operator,
				fieldObject: new Field({
					id: segmentId,
					name: column.get('displayName') || column.get('name'),
					type: 'BOOL'
				}),
				columnType: 'SEGMENT'
			});

			if (typeof value !== 'undefined') {
				equalsFilter.setValue(0, value);
			}

			return equalsFilter;
		},

		addFieldEqualsValueSegmentFilter: function(column, value) {

			var segmentId = '';

			if (column.get && column.get('segmentId')) {
				segmentId = column.get('segmentId');
			}

			if (column.segmentId) {
				if (_.isFunction(column.segmentId)) {
					segmentId = column.segmentId();
				} else {
					segmentId = column.segmentId;
				}
			}

			var filterExists = !!this.filter().get('filterCollection').models.filter(function(filter) {
				if (filter.get('fieldObject')) {
					return filter.get('fieldObject').get('id') === segmentId;
				}
			})[0];

			var equalsFilter = this.getFieldEqualsValueSegmentFilter(column, value);

			if (filterExists) {
				this.filter().replaceFilter(equalsFilter);
			} else {
				this.filter().addFilter(equalsFilter);
			}
		},

		parse: function(data) {
			var domain = APP.domains.get(data.domainId);
			var constructorData = {
				builder: this,
				id: data.id,
				name: data.name,
				description: data.description,
				domainId: data.domainId,
				dashboardId: data.dashboardId,
				domain: domain,
				owner: data.owner,
				isPrivate: data.isPrivate,
				isFollowing: data.isFollowing ? data.isFollowing : false,
				distrInfo: data.distrInfo,
				threshold: data.threshold,
				reportType: data.reportType,
				dateModified: data.dateModified,
				dateCreated: data.dateCreated,
				options: data.visual && data.visual.options || {}
			};

			// Set necessary column data
			_.each(data.columns, function(columnData, i) {
				var fnCol;

				if (columnData.columnType === 'FUNCTION') {
					if (domain) {
						fnCol = _.find(domain.get('functions'), function(fn) {
							return fn.name === columnData.function;
						});
						if (!columnData.name) {
							columnData.name = fnCol.displayName;
						}

						if (!columnData.type) {
							columnData.type = fnCol.type;
						}
					}

					if (!columnData.asName) {
						columnData.asName = columnData.name;
					}
				}

				if (columnData.columnType === 'SEGMENT') {
					if (!columnData.name) {
						columnData.name = columnData.asName;
					}
				}

				columnData.arrangement = i;
				if (constructorData.options && constructorData.options.columns) {
					var columnOptions = _.find(JSON.parse(constructorData.options.columns), function(c) {
						if (c) {
							if (c.fieldId) {
								return c.fieldId === columnData.fieldId;
							} else if (c.segmentId) {
								return c.segmentId === columnData.segmentId;
							} else if (c.function) {
								return c.function === columnData.function;
							} else {
								return false;
							}
						} else {
							return false;
						}
					});

					if (columnOptions) {
						columnData.isPercentage = columnOptions.isPercentage;
					}
				}
			});

			// Build the column objects
			constructorData.columns = _.map(data.columns, function(column) {
				return domain && column ? domain.buildColumn(column) : null;
			});

			// Order columns
			var newCollection = [];
			var i = 0;

			var findColumn = function(col) {
				var order;

				if (constructorData.options.columns) {
					order = JSON.parse(constructorData.options.columns)[i];
				}

				if (order.uniqueId) {
					return order.uniqueId === col.get('uniqueId');
				} else {

					if (col.get('function')) {
						return order.function === col.get('function') &&
							order.function === col.get('function') &&
							order.isPercentage === col.get('isPercentage') &&
							order.aggregation === col.get('aggregation');
					} else {
						return order.fieldId === col.get('fieldId') &&
							order.segmentId === col.get('segmentId') &&
							order.isPercentage === col.get('isPercentage') &&
							order.aggregation === col.get('aggregation');
					}
				}
			};

			if (constructorData.options.columns) {
				for (i = 0; i < JSON.parse(constructorData.options.columns).length; i++) {
					if (constructorData.columns[i] && constructorData.columns[i] !== null) {
						var match = _.find(constructorData.columns, findColumn);
						if (match) {
							newCollection.push(match);
						}
					}
				}
			}

			if (newCollection.length > 0) {
				constructorData.columns = newCollection;
			}

			// Set filters
			if (data.filters) {
				constructorData.filter = domain ? domain.buildFilter(data.filters) : null;
			} else {
				constructorData.filter = domain ? domain.buildCompoundFilter({
					operator: 'AND'
				}) : null;
			}

			return constructorData;
		},

		runWithSubstituteFilter: function(replacementFilter) {
			this.get('filter').substitute(replacementFilter);
			this.run();
			this.get('filter').unsubstitute();
		},

		applyMasterFilter: function() {
			this.get('filter').substitute(this.get('domain').getMasterFilter().clone());
		},

		getMasterFilter: function() {
			return this.get('filter').substitute(this.get('domain').getMasterFilter());
		},

		hasData: function() {
			var results = this.get('results');
			return results && results.rows && results.rows.length > 0;
		},

		getSelectedColumn: function() {
			if (this.getVisualization() === 'donut-chart') {
				var selectedColumn = this.getOption('selectedColumn');
				if (selectedColumn) {
					selectedColumn = selectedColumn.split('_');
					selectedColumn.shift();
					if (selectedColumn[0] === 'elapsedtime') {
						var columns = this.columns().models;
						for (var i = 0; i < columns.length; i++) {
							var c = columns[i];
							if (c.get('columnType') === 'FUNCTION') {
								var fields = _.pluck(c.get('funcArguments'), 'fieldId').join('_');
								var selected = selectedColumn.slice(1, -1).join('_');
								if (fields === selected) {
									selectedColumn = c.get('name');
								}
							}
						}
					} else {
						selectedColumn = selectedColumn.slice(0, -1).join('_');
					}
					return selectedColumn;
				} else {
					return null;
				}
			} else {
				return null;
			}
		},

		isColumnPercentage: function(columnName) {
			var column = this.columns().filter(function(c) {
				if (c.fieldId() === columnName) {
					return true;
				}
			});

			if (column !== null && column !== undefined && column.length > 0) {
				return column[0].isPercentage();
			} else {
				return false;
			}
		},

		getColumnByName: function(columnName) {
			var column = this.columns().filter(function(c) {
				if (c.get('columnType') === 'FUNCTION' || c.get('columnType') === 'SEGMENT') {
					if (c.get('name') === columnName) {
						return true;
					}
				} else if (c.fieldId() === columnName) {
					return true;
				}
			});
			if (column !== null && column !== undefined && column.length > 0) {
				return column[0];
			} else {
				return null;
			}
		},

		clone: function() {
			var attributes = _.clone(this.attributes);
			var columns = this.attributes.columnCollection;
			attributes.options = _.clone(this.attributes.options);
			attributes.columns = undefined;
			attributes.columnCollection = new columns.constructor(_.map(columns.models, function(m) {
				return m.clone();
			}));
			attributes.filter = attributes.filter.clone();
			return new this.constructor(attributes);
		},

		getReportSegmentIds: function(report) {
			var segmentsIds = [];

			// get segments from columns
			_.each(report.columns, function(columnData) {
				if (columnData.columnType === 'SEGMENT' && segmentsIds.indexOf(columnData.segmentId) === -1) {
					segmentsIds.push(columnData.segmentId);
				}
			});

			// get segments from filters
			var collection = this.filter().filterCollection().clone();
			_.each(collection.models, function(filter) {
				if (filter.get('columnType') === 'SEGMENT' && segmentsIds.indexOf(filter.fieldId()) === -1) {
					segmentsIds.push(filter.fieldId());
				}

				if (filter.get('segmentId') && segmentsIds.indexOf(filter.get('segmentId')) === -1) {
					segmentsIds.push(filter.get('segmentId'));
				}
			});

			return segmentsIds;
		},

		isMetric: function() {
			return this.getReportType() === reportTypes.METRIC;
		}
	});
});

